// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseSetupDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
import uiState from 'logic/Izenda.UiState';
import { isEmpty, isNil, isArray } from 'lodash/fp';
const MACHINE_LEARNING_URL ='MachineLearning/';
const FUSION_URL = 'fusion/';

export default {


     /** Predicted Field API for displaying model information  */


  getPredictedFieldModels(tableSourceId){
     return fetch(`${MACHINE_LEARNING_URL}modelDetails/${tableSourceId}`).get();
  },



  checkMLServerSettings(serverIpAddress){
      let data = {
        ServerIp : serverIpAddress
      }
      return fetch(`${MACHINE_LEARNING_URL}predictionServerConnectivity`).post(data);
  },

  checkMLDBSettings(ConnectionString,ipAdd){
    let data = {
    ServerIp : ipAdd, 
    ConnectionString : ConnectionString
    }
    return fetch(`${MACHINE_LEARNING_URL}mLDatabaseConnectivity`).post(data);
    },

    saveMLSettings(data){
        return fetch(`${MACHINE_LEARNING_URL}mlSetting`).post(data);
    },

    saveMLNLQSettings(data){
      return fetch(`${MACHINE_LEARNING_URL}mlNLQSetting`).post(data);
  },

    getMLSettingsDetail(){
      return fetch(`${MACHINE_LEARNING_URL}predictionServerIP`).get();
    },

    getDBSettingsDetail(){
      return fetch(`${MACHINE_LEARNING_URL}mlConnInfo`).get();
    }

    

};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.MLSettingsFetcher.js